export const formatPriceToEuroString = (nr: number) =>
  Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(nr);

export const formatPrice = (nr: number) => Intl.NumberFormat('nl-NL', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    useGrouping: false,
  }).format(nr);
